import { ArrowUpRight, Sparkles } from "lucide-react";
import { offerDate } from "@/data/offers";
import { useBrokers } from "@/context/BrokersContext";

export const OfferCard = ({ offer, featured, onView }) => {
  const { getBroker } = useBrokers();
  const broker = getBroker(offer.brokerSlug);
  if (!broker) return null;
  return (
    <article className={`offer-card ${featured ? "offer-card-featured" : ""}`} data-testid={`offer-card-${offer.id}`}>
      <div className="offer-card-top">
        <div className="offer-broker"><img src={broker.logo} alt="" width="40" height="40" data-testid={`offer-logo-${offer.id}`} /><span data-testid={`offer-broker-${offer.id}`}>{broker.name}</span></div>
        <span className="offer-category" data-category={offer.category} data-testid={`offer-category-${offer.id}`}>{offer.category}</span>
      </div>
      <div className="offer-card-main">
        <div className="offer-card-copy">
          {featured && <p className="offer-featured-label" data-testid="offer-featured-label"><Sparkles size={12} /> Featured offer</p>}
          <h2 className="t-h5" data-testid={`offer-title-${offer.id}`}>{offer.title}</h2>
          {featured && <p className="offer-description">{offer.description}</p>}
        </div>
        <div className="offer-benefit-block" data-testid={`offer-benefit-${offer.id}`}><p className="offer-benefit">{offer.benefit}</p><p className="offer-benefit-label">{offer.benefitLabel}</p></div>
      </div>
      <div className="offer-card-bottom"><p data-testid={`offer-expiry-${offer.id}`}>Ends <time dateTime={offer.expiresAt}>{offerDate(offer.expiresAt)}</time></p><button className="offer-view-button" onClick={() => onView(offer)} data-testid={`offer-view-${offer.id}`}>View offer <ArrowUpRight size={14} /></button></div>
    </article>
  );
};